module.exports = __webpack_public_path__ + "media/img/pages/career-starter/hero-de-a9ff8a146cb03f95e1a1af2561ef7f68.png";